import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function DS_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-6'>1. Introduction to Data Science</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          What is data science, Applications & key components of data sciences, Data science as carrier
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-6'>2. Introduction to Machine learning</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Machine learning life cycle, Applications of machine learning, Types of machine learning, Overview of anaconda & jupyter notebook, Installation of anaconda.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-6'>3. Introduction to Python</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Python fundamentals (operators, conditionals, loops, functions) Python data structure (lists, tuples, dictionary, set, arrays).
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-6'>4. Python for Data science</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            File handling in python, NumPy, Pandas, Matplotlib, Seaborn.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-6'>5. Data collection</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Data collection from files (CSV/EXCELS) Data collection from database (MYSQL/ SQLITE) Data collection from API’s Data collection through web scraping (beautiful soup/selenium).
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-6'>6. Data wrangling & visualization</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Data cleaning & preprocessing using NumPy & pandas, Data visualization using Matplotlib, seaborn, tableau.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-6'>7. Machine learning Algorithms for DS</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Linear & logistic regression, Decision tree, Random Forest, Navie bayes & K nearest Neighbours, SVM & Clustering, K-Means & K-MEDOIDS.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-6'>8. DEEP LEARNING</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            NLP, Neural networks, TensorFlow, Keras.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel9bh-content"
          id="panel9bh-header"
        >
        <Typography className='fs-6'>9. Time series</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Time series analysis with Pandas, Time series analysis with FB Prophet.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel10bh-content"
          id="panel10bh-header"
        >
        <Typography className='fs-6'>10. BI tools</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Intro to business intelligence, Use of business intelligence tools at industries.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel11bh-content"
          id="panel11bh-header"
        >
        <Typography className='fs-6'>11. WEBAPP</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Webapp using streamlit.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel12'} onChange={handleChange('panel12')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel12bh-content"
          id="panel12bh-header"
        >
        <Typography className='fs-6'>12. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor and Major Project and project overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
